import ProgressiveImage from './ProgressiveImage';
export default ProgressiveImage;
